<template>
	<div class="container mx-auto max-w-5xl px-4">
		<div class="flex flex-col justify-between">
			<div class="flex overflow-hidden">
				<HelpfulTips>
					Please select all that are true. For example, if your A/C is blowing warm select
					“A/C and Heater.” If your ride does not have any issues that you know of please
					select “None”.
					<br />
					Please use the comments box to tell us more about your ride's mechanical
					condition if there are other important details.
				</HelpfulTips>

				<div class="grow basis-1/2 overflow-y-auto">
					<div
						v-for="issue in form.mechIssueList"
						:key="issue.id"
						class="box-border flex cursor-pointer flex-col pl-4 pb-6 lg:pr-6"
						@click="toggleIssue(issue)"
					>
						<div class="text-main-400 flex select-none items-center text-xl font-bold">
							<AppCheckbox
								class="text-success-base xs:mr-6 mr-3"
								:class="{
									'text-warning': issue.key !== 'None',
								}"
								:checked="form.mechIssueItems.some(mi => mi.id === issue.id)"
							/>

							{{ issue.name }}
						</div>

						<div
							v-if="
								issue.key !== 'None' &&
								form.mechIssueItems.some(mi => mi.id === issue.id)
							"
							class="select-none"
							@click.stop=""
						>
							<AppInput
								v-model="form.mechIssueItems[getItemIndex(issue)].comment"
								class="mb-2"
								type="text"
								input-class="py-2 pl-0 h-auto w-full rounded-none shadow-none focus:shadow-none !border-b-solid border-white border-b-main-300 focus:border-solid !focus:border-white focus:border-b-main-400 outline-none"
								placeholder="Any additional comments?"
							>
								<template #append>
									<PencilSvg
										class="xs:-right-8 absolute -top-2 -right-6 h-4 w-4 md:-top-1.5"
									/>
								</template>
							</AppInput>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
	import { QuizItem, useFormStore } from '../../../stores/form'
	import AppInput from '../../common/AppInput.vue'
	import PencilSvg from '../components/icons/PencilSvg.vue'
	import HelpfulTips from '../components/HelpfulTips.vue'
	import AppCheckbox from '../../common/AppCheckbox.vue'

	// hooks
	const form = useFormStore()

	// methods
	const getItemIndex = (issue: QuizItem) => {
		return form.mechIssueItems.findIndex(mi => mi.id === issue.id)
	}

	const toggleIssue = (issue: QuizItem): void => {
		if (issue.key === 'None') {
			form.mechIssueItems = [{ ...issue, comment: '' }]
			return
		}

		const noneIndex = form.mechIssueItems.findIndex(mi => mi.key === 'None')
		if (~noneIndex) {
			form.mechIssueItems.splice(noneIndex, 1)
		}

		const index = form.mechIssueItems.findIndex(mi => mi.id === issue.id)
		if (~index) {
			form.mechIssueItems.splice(index, 1)
		} else {
			form.mechIssueItems.push({ ...issue, comment: '' })
		}
	}
</script>
